import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../composables/theme';

export const useStyles = () => {
  const theme = useTheme();

  const baseClass = computed(() => css({
    '&, & > *': {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box',
    },
    opacity: 0,
    borderRadius: '10px',
    overflow: 'hidden',
    border: `1px solid ${theme.value.colors.gray.light3}`,
    background: '#fff',
    boxShadow: '4px 4px 30px 0px rgba(0, 0, 0, 0.10)',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    transition: 'opacity 0.3s ease-in-out',
    '&--non-blocking': {
      zIndex: 50,
    },
    '&--small': {
      width: '22.5rem',
    },
    '&--medium': {
      width: '35rem',
    },
    '&--large': {
      width: '40rem',
    },
    '&--extra-large': {
      width: '56rem',
    },
    '&--active': {
      opacity: 1,
    },
    '&:focus': {
      outline: 'none',
    },
    '&::backdrop': {
      background: 'rgba(226, 226, 226, 0.80)',
      transition: 'all 0.3s ease-in-out',
    },
    '> *': {
      width: '100%',
      paddingInline: '2.5rem',
    },
    '&__header': {
      paddingBlock: '1rem',
      background: '#fff',
    },
    '&__close-button': {
      cursor: 'pointer',
      border: 'none',
      background: 'transparent',
    },
    '&--featured > &__header': {
      background: theme.value.colors.gray.light3,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    '&__body': {
      paddingTop: '1.5rem',
      paddingBottom: '1.5rem',
      background: '#fff',
      overflow: 'auto',
    },
    '&__footer': {
      paddingTop: '1rem',
      paddingBottom: '1.5rem',
      background: '#fff',
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '1rem',
    },
    '&__backdrop': {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(226, 226, 226, 0.80)',
      zIndex: 45,
    },
  }));

  return baseClass;
};
